import { useRef, useState } from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import { useUnsafeCallback } from 'modules/core/hooks/useCallback'
import { useUnsafeEffect } from 'modules/core/hooks/useEffect'

interface ResizeProps {
  setResizeHeight: (height: number) => void
  resizeRef: React.RefObject<HTMLDivElement>
  resize: boolean
}

const Resize = ({ setResizeHeight, resizeRef, resize }: ResizeProps) => {
  const [hover, setHover] = useState(false)
  const isResizing = useRef(false)
  const startY = useRef(0)
  const startHeight = useRef(0)
  const HEADER_OFFSET = 40

  const handleMouseDown = useUnsafeCallback((ev: MouseEvent) => {
    if (!resizeRef?.current || !resize) return

    isResizing.current = true
    startY.current = ev.clientY
    startHeight.current = resizeRef.current.offsetHeight - HEADER_OFFSET

    document.addEventListener('mousemove', handleMouseMove)
    document.addEventListener('mouseup', handleMouseUp)
  }, [])

  const handleMouseMove = useUnsafeCallback((ev: MouseEvent) => {
    if (!isResizing.current || !resizeRef.current) return

    const deltaY = ev.clientY - startY.current
    const newHeight = startHeight.current + deltaY

    setResizeHeight(newHeight)
  }, [])

  const handleMouseUp = useUnsafeCallback(() => {
    isResizing.current = false
    document.removeEventListener('mousemove', handleMouseMove)
    document.removeEventListener('mouseup', handleMouseUp)
  }, [handleMouseMove])

  const handleMouseLeave = () => {
    if (!isResizing.current) {
      setHover(false)
    }
  }

  useUnsafeEffect(() => {
    const resizeHandle: HTMLElement | null = document.querySelector('#header-resize')
    if (resizeHandle && resize) {
      resizeHandle.addEventListener('mousedown', handleMouseDown)
    }

    return () => {
      if (resizeHandle && resize) {
        resizeHandle.removeEventListener('mousedown', handleMouseDown)
      }

      document.removeEventListener('mousemove', handleMouseMove)
      document.removeEventListener('mouseup', handleMouseUp)
    }
  }, [handleMouseDown, handleMouseMove, handleMouseUp])

  return (
    <Box
      id="header-resize"
      onMouseEnter={() => setHover(true)}
      onMouseLeave={handleMouseLeave}
      height={hover && resize ? 's6' : 's1'}
      background="grey300"
      width="full"
      position="absolute"
      style={{
        top: '0',
        left: '0',
        right: '0',
        zIndex: '3',
        userSelect: 'none',
        cursor: hover && resize ? 'row-resize' : '',
      }}
    ></Box>
  )
}

export { Resize }
